import React from "react";
// Styled
import { Tag as TagWrapper } from './tag.styled';

export const Tag = ({ children, type, size }) => {

    const styleType = type ? type : 'positive';
    const styleSize = size ? size : 'normal';
    
    return (
        <TagWrapper
            type={styleType}
            fontSize={styleSize}
        >
            {children}
        </TagWrapper>
    )

}